import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  CardBody,
  CardHeader,
  Icon,
  Table,
  useToggle,
} from '@met/react-components';
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

import { ConfirmationModal, LinkButton } from '../../../components';
import { Green, Red } from '../styled';

const LanguageNamespacesCard = ({
  project,
  languageKey,
  onDeleteLanguage,
  onDeleteNamespace,
}) => {
  const [deleteLanguageModalHidden, toggleDeleteLanguageModal] = useToggle(
    true
  );
  const [deleteNamespaceModalHidden, toggleDeleteNamespaceModal] = useToggle(
    true
  );
  const [namespaceToDelete, setNamespaceToDelete] = useState(null);

  const handleDeleteLanguageClick = () => {
    return onDeleteLanguage(project.languages[languageKey].id);
  };

  const handleDeleteNamespaceClick = namespaceId => {
    setNamespaceToDelete(namespaceId);
    toggleDeleteNamespaceModal();
  };

  const deleteNamespace = () => {
    onDeleteNamespace(namespaceToDelete).then(() =>
      toggleDeleteNamespaceModal()
    );
  };

  const cols = {
    namespaceName: {
      label: 'Namespace',
    },
    keyCompletion: {
      label: 'Keys',
      content: namespace =>
        namespace.keyCount === 0 ||
        namespace.translationsCount / namespace.keyCount === 1 ? (
          <Green>
            {namespace.translationsCount} / {namespace.keyCount}
          </Green>
        ) : (
          <Red>
            {namespace.translationsCount} / {namespace.keyCount}
          </Red>
        ),
    },
    status: {
      label: 'Status',
      content: namespace =>
        namespace.keyCount === 0 ||
        namespace.translationsCount / namespace.keyCount === 1 ? (
          <Green>Complete</Green>
        ) : (
          <Red>Not Complete</Red>
        ),
    },
    actions: {
      label: 'Actions',
      content: namespace => (
        <div>
          <Link
            to={`/projects/${project.projectId}/languages/${project.languages[languageKey].id}/namespaces/${namespace.namespaceId}/translations`}
          >
            <Icon type='pencil' />
          </Link>
          <LinkButton
            style={{ marginLeft: '.8rem' }}
            onClick={() => handleDeleteNamespaceClick(namespace.namespaceId)}
          >
            <Icon type='trash' />
          </LinkButton>
        </div>
      ),
    },
  };

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <span>{`${languageKey} - ${project.languages[languageKey].description}`}</span>
          <span
            style={{
              marginLeft: 'auto',
              display: languageKey === 'en' ? 'none' : 'block',
            }}
          >
            <LinkButton onClick={toggleDeleteLanguageModal}>
              <Icon type='trash' />
            </LinkButton>
          </span>
        </CardHeader>
        <CardBody>
          <Table
            striped
            borderless
            columns={cols}
            uniqueKeyId='namespaceId'
            data={project.languages[languageKey].namespaces}
          />
        </CardBody>
      </Card>
      <ConfirmationModal
        hidden={deleteLanguageModalHidden}
        toggle={toggleDeleteLanguageModal}
        onConfirm={handleDeleteLanguageClick}
        body={
          'Are you sure you want to delete this language? This action cannot be undone.'
        }
      />
      <ConfirmationModal
        hidden={deleteNamespaceModalHidden}
        toggle={toggleDeleteNamespaceModal}
        onConfirm={deleteNamespace}
        body={
          'Are you sure you want to delete this namespace? All translations across all languages for this project will be deleted. This action cannot be undone.'
        }
      />
    </Fragment>
  );
};

export default LanguageNamespacesCard;
